export default __webpack_public_path__ + "static/sso-agile-d5b3e23e2b144d070dd4c2f6b1ddb50c.png";